import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import AddButton from 'components/v2/buttons/AddButton';
import CargomaticInput from 'components/v2/input';
import CargomaticSelect from 'components/v2/select';
import { defaultLoad, dimensionalUnits, loadSchema, weightUnits, weightUnitsOptions, } from 'utils/localization/types';
import DescriptionListItem from 'components/v2/DescriptionListItem';
import { LocaleContext } from 'providers/locale-settings-context';
import Loads from './Loads';
const LoadDetailsForm = ({ loadOnly, loads, fullTruckload, totalShipmentWeight, shipmentWeightUnit, addLoad, onRemoveLoad, onLoadFieldChange, onTotalShipmentWeightChange, }) => {
    const { t } = useTranslation();
    const [selectedLoads, setSelectedLoads] = useState([]);
    const { localeData } = useContext(LocaleContext);
    useEffect(() => {
        setSelectedLoads(loads);
    }, [loads]);
    const addLoadhandler = () => {
        var _a, _b;
        let prevLoads = [...selectedLoads];
        prevLoads.push(Object.assign(Object.assign({}, defaultLoad), { weight_units: ((_a = selectedLoads[0]) === null || _a === void 0 ? void 0 : _a.weight_units) ||
                (localeData === null || localeData === void 0 ? void 0 : localeData.weight_units) ||
                weightUnits[0], dimensional_units: ((_b = selectedLoads[0]) === null || _b === void 0 ? void 0 : _b.dimensional_units) ||
                (localeData === null || localeData === void 0 ? void 0 : localeData.dimensional_units) ||
                dimensionalUnits[0] }));
        addLoad(prevLoads);
    };
    const removeLoad = (index) => {
        return [
            ...selectedLoads.slice(0, index),
            ...selectedLoads.slice(index + 1),
        ];
    };
    const handleRemoveLoad = (index) => {
        const newLoads = removeLoad(index);
        onRemoveLoad(newLoads, index);
    };
    const handleLoadFieldChange = (field, value, index) => {
        const currentLoads = selectedLoads;
        let parsedValue;
        if (field === 'stackable' ||
            field === 'type' ||
            field === 'weight_units' ||
            field === 'dimensional_units') {
            parsedValue = value;
        }
        else if (field === 'weight' || field === 'height') {
            parsedValue = parseFloat(value);
            parsedValue = !Number.isNaN(parsedValue) ? parsedValue : undefined;
        }
        else {
            parsedValue = parseInt(value, 10);
            parsedValue = !Number.isNaN(parsedValue) ? parsedValue : undefined;
        }
        if (field === 'weight_units' || field === 'dimensional_units') {
            const loads = (currentLoads || []).map((load) => {
                return Object.assign(Object.assign({}, load), { [field]: parsedValue });
            });
            return onLoadFieldChange(loads, field, value, index);
        }
        const load = Object.assign(Object.assign({}, selectedLoads[index]), { [field]: parsedValue });
        const loads = [
            ...currentLoads.slice(0, index),
            load,
            ...currentLoads.slice(index + 1),
        ];
        onLoadFieldChange(loads, field, value, index);
    };
    function renderShipmentWeight() {
        if (!fullTruckload) {
            return (React.createElement(DescriptionListItem, { label: t('TOTAL_SHIPMENT_WEIGHT'), className: "text-sm font-medium text-gray-500" },
                React.createElement("dd", { className: "mt-1 text-sm text-gray-900" },
                    totalShipmentWeight,
                    " ",
                    shipmentWeightUnit)));
        }
        return (React.createElement("div", { className: "flex items-center mb-0 space-x-4" },
            React.createElement(CargomaticInput, { type: "number", label: t('TOTAL_SHIPMENT_WEIGHT'), placeholder: t('TOTAL_SHIPMENT_WEIGHT'), min: 0, value: totalShipmentWeight, onChange: (value) => onTotalShipmentWeightChange(value) }),
            React.createElement(CargomaticSelect, { showCaption: true, label: t('WEIGHT_UNIT'), selected: shipmentWeightUnit, className: "w-20", items: weightUnitsOptions, onSelect: (item) => {
                    handleLoadFieldChange('weight_units', item.value, 0);
                }, applyDefaultMargins: false, valueKey: "value", textKey: "localizationSlug" })));
    }
    return (React.createElement("div", { className: "my-6 space-y-4" },
        React.createElement("header", { className: "flex items-center justify-between mb-0 space-x-4" },
            !fullTruckload && (React.createElement("div", { className: "flex items-center mb-0 space-x-4" },
                React.createElement("h3", { className: "my-0" }, t('LOAD')),
                React.createElement(AddButton, { onClick: addLoadhandler }))),
            !loadOnly && renderShipmentWeight()),
        !fullTruckload && (React.createElement("div", { className: "overflow-x-auto" },
            React.createElement("table", { className: "w-full table-fixed default-table" },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", { className: "", style: { width: '150px' } }, t('TYPE')),
                        React.createElement("th", { className: "", style: { width: '120px' } }, t('QUANTITY')),
                        React.createElement("th", { className: "", style: { width: '120px' } }, t('LENGTH')),
                        React.createElement("th", { className: "", style: { width: '120px' } }, t('WIDTH')),
                        React.createElement("th", { className: "", style: { width: '120px' } }, t('HEIGHT')),
                        React.createElement("th", { className: "", style: { width: '175px' } }, t('DIMENSIONAL_UNIT')),
                        !loadOnly && (React.createElement("th", { className: "", style: { width: '120px' } }, t('TOTAL_WEIGHT'))),
                        !loadOnly && (React.createElement("th", { className: "", style: { width: '175px' } }, t('WEIGHT_UNIT'))),
                        React.createElement("th", { style: { width: '120px' } },
                            t('STACKABLE_TITLE'),
                            "?"),
                        React.createElement("th", { style: { width: '120px' } }, "\u00A0"))),
                React.createElement("tbody", null, selectedLoads.map((load, i) => {
                    return (React.createElement(Loads, { loadOnly: loadOnly, index: i, key: i, load: load, onLoadFieldChange: (field, value) => handleLoadFieldChange(field, value, i), onRemoveLoad: () => handleRemoveLoad(i) }));
                })))))));
};
LoadDetailsForm.propTypes = {
    fullTruckload: PropTypes.bool.isRequired,
    loads: PropTypes.arrayOf(PropTypes.shape(Object.assign({}, loadSchema))),
    onLoadFieldChange: PropTypes.func.isRequired,
    addLoad: PropTypes.func.isRequired,
    onRemoveLoad: PropTypes.func.isRequired,
    onTotalShipmentWeightChange: PropTypes.func.isRequired,
};
LoadDetailsForm.defaultProps = {
    loads: [],
};
export default LoadDetailsForm;
